import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Login from './Login'; // 假設有一個 Login 組件用於登入
import { Helmet } from 'react-helmet';

// 從本地存儲中讀取初始登入狀態
const initialLoggedInState = localStorage.getItem('isLoggedIn') === 'true';

ReactDOM.render(
  <React.StrictMode>
    <Helmet>
      {/* Noto Sans Traditional Chinese 中文字體 / Google  */}
      <link rel="preconnect" href="https://fonts.googleapis.com"/>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100..900&display=swap" rel="stylesheet"/>

      {/*  Roboto 英文字體 / Google */}
      <link rel="preconnect" href="https://fonts.googleapis.com"/>
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin/>
      <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+TC:wght@100..900&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap" rel="stylesheet"></link>
    </Helmet>
    {initialLoggedInState ? (
      <App handleLogout={() => { localStorage.setItem('isLoggedIn', 'false'); }} />
    ) : (
      <Login onLogin={() => { localStorage.setItem('isLoggedIn', 'true'); }} />
    )}
  </React.StrictMode>,
  document.getElementById('root')
);
